import { Box } from '@mui/material'
import React from 'react'
import AppBar from '@mui/material/AppBar'
import { styled } from '@mui/material/styles'
import { appBarConfigObject } from '../../config'
import { TChildElementProps } from '../../types'
import { useLayoutContext } from '../../Context/LayoutContext'

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.text.primary,
}))

export const HeaderLayoutBox = ({ children }: TChildElementProps) => {
  //   const isMobileLayout = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  //   const isDesktopLayout = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'))
  //getting the layout selected by context
  const layoutSelected = useLayoutContext()
  //using layout config according to layout selected
  const selectedLayout = appBarConfigObject[layoutSelected]
  return (
    <StyledAppBar sx={{ p: '0.5rem' }} position='static'>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: selectedLayout.gridTemplateColumns,

          gridTemplateRows: selectedLayout.gridTemplateRows,

          columnGap: selectedLayout.gap,

          gridTemplateAreas: selectedLayout.gridTemplateAreas,
        }}
      >
        {/* <img style={{ width: '4rem', height: '3rem' }} src={court} />
        <Typography sx={{ p: '0.4rem' }} variant='h5'>
          {'City of Sulphur Springs'}
        </Typography> */}
        {children}
      </Box>
    </StyledAppBar>
  )
}
